export default "__VITE_ASSET__BAIQdPh$__"